const DEFAULT_FORBIDDEN_MESSAGE =
  'You do not have permission to access this resource.';

type ApiErrorBody = {
  detail?: string | { msg?: string }[];
  response?: { message?: string };
  message?: string;
};

function detailToString(detail: ApiErrorBody['detail']): string | null {
  if (typeof detail === 'string' && detail.trim()) {
    return detail.trim();
  }
  if (Array.isArray(detail)) {
    const parts = detail
      .map((item) => (typeof item?.msg === 'string' ? item.msg.trim() : ''))
      .filter(Boolean);
    if (parts.length > 0) {
      return parts.join(' ');
    }
  }
  return null;
}

export function isForbiddenError(error: unknown): boolean {
  const status = (error as { response?: { status?: number } })?.response?.status;
  return status === 403;
}

export function isPermissionDeniedMessage(message: string): boolean {
  const normalized = message.trim().toLowerCase();
  return (
    normalized.includes('permission denied') ||
    normalized.includes('permissions denied') ||
    normalized.includes('access denied') ||
    normalized.includes('do not have permission') ||
    normalized.includes('not authorized') ||
    normalized.includes('forbidden')
  );
}

export function extractForbiddenMessage(error: unknown): string {
  const data = (error as { response?: { data?: ApiErrorBody } })?.response?.data;
  if (!data) {
    return DEFAULT_FORBIDDEN_MESSAGE;
  }

  const responseMessage = data.response?.message;
  if (typeof responseMessage === 'string' && responseMessage.trim()) {
    return responseMessage.trim();
  }

  const detailMessage = detailToString(data.detail);
  if (detailMessage) {
    return detailMessage;
  }

  if (typeof data.message === 'string' && data.message.trim()) {
    return data.message.trim();
  }

  return DEFAULT_FORBIDDEN_MESSAGE;
}
